// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "c29d8f2b0d331dc06e4ac8fabf0a22fa" + ".js";
};